import { useDispatch } from '../Store/storeProvider';
import setupCookies from '../Helpers/setupCookies';
import Metering from '../Handlers/Metering';
import { readCookie } from '../Helpers/Cookies';
import {
    setSuscriptorType,
    setRegistrado,
    save,
    setUserId,
    createCustomDimension,
} from '../Helpers/CustomDimension';
import useFinalFlow from './useFinalFlow';
import UCL from '../Helpers/UserClientLibs';
const useMeHandler = () => {
    const dispatch = useDispatch();
    const [handleFinalFlow] = useFinalFlow();

    const handler = async (resp, User, callback) => {
        try {
            let { Usuario: usuarioMe } = JSON.parse(resp.response);

            dispatch({
                type: 'USER_ADD_VALUES',
                value: {
                    ClubNacion: usuarioMe.ClubNacion || '',
                    Avatar: usuarioMe.Usuario_detalle_foto_perfil,
                    Email: usuarioMe.usuarioemail,
                    UsuarioDetalleApellido: usuarioMe.UsuarioDetalleApellido,
                    UsuarioDetalleNombre: usuarioMe.UsuarioDetalleNombre,
                },
            });

            setupCookies(usuarioMe);

            const onFinalizarMe = () => {
                let combotype = readCookie('gaComboType');
                if (combotype) {
                    setSuscriptorType(combotype);
                } else {
                    setSuscriptorType('N/A');
                }

                //CustomDimension
                setRegistrado('yes');
                save();
                createCustomDimension();

                //Metodo que abre en dif caminos el final de flow
                //dependiendo del estado del user ( modo, tipo cred, etc)
                handleFinalFlow(usuarioMe?.ClubNacion, User, callback);
            };

            await Metering.obtenerCookieSuscriptor();

            //CustomDimension
            setUserId(usuarioMe.UsuarioId);
            save();

            try {
                await UCL.RefreshAsync();
            } catch (error) {
                console.log(error);
            }

            onFinalizarMe();
        } catch (error) {
            console.error(error, ' error handleMeService');
            dispatch({
                type: 'ERROR PAGE COMPONENT',
                value: 'error generico',
            });
            throw error;
        }
    };

    return [handler];
};

export default useMeHandler;
